import React from 'react';
import { Box } from '@mui/material';
import Logo from './Logo';

const Footer = () => {
  return (
    <Box 
      sx={{ 
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        mt: 'auto',
        py: 2,
        transform: 'scale(0.6)'
      }}
    >
      <Logo />
    </Box>
  );
};

export default Footer;
